
import { INode } from "@/types/INode";
import { Component, Vue, Prop } from "vue-property-decorator";
import Clip from "./Clip";
import  ButtonVue from "@/lib/Button.vue";

@Component({ components: { ButtonVue} })
export default class ClipAddVue extends Vue {
  public static clip:Clip=new Clip().getClip(); 
  @Prop(Object) to_add!:INode;
  @Prop(String) type:string|undefined;
  _to_add:INode|undefined=undefined;
  key=0

  add() {   
    if (this._to_add && this.type) {
      this._to_add.type = this.type;
      ClipAddVue.clip.add(this._to_add);
    }
  }

  mounted() {
    if (this.type && this.to_add && ClipAddVue.clip) {
      this._to_add=this.to_add
      this.key++
    } 
  }
}
